<template lang="pug">
    div.minutaContent(v-if='informacoesMinuta')
        div.linha
            div.coluna.centralizado
                b MINUTA DO TCPRA
        div.linha
            div.coluna.centralizado
                b TCPRA-TERMO DE COMPROMISSO DO PROGRAMA DE REGULARIZAÇÃO AMBIENTAL
        div.linha
            div.coluna.centralizado (artigo 59, § 3º, da Lei federal nº 12.651, de 25 de maio de 2012)
        div.linha
        div.linha

        div.linha
            div.coluna
                b NÚMERO DO TCPRA:
                span {{ informacoesMinuta.numeroTCPRA }}
        div.linha
            div.coluna
                b NÚMERO DO CAR: 
                span {{ informacoesMinuta.numeroCAR }}
        div.linha
            div.coluna
                b NÚMERO DO PRADA: 
                span {{ informacoesMinuta.numeroPRADA }}

        div.linha

        div.linha
            div.coluna
                | A(s) pessoa (s) física (s) ou jurídica (s), abaixo identificada (s), à vista do que
                | determina o artigo 59, § 3º, da Lei federal nº 12.651, de 25 de maio de 2012, e
                | considerando a sua opção em aderir ao Programa de Regularização Ambiental-PRA,
                | disciplinado no Estado de São Paulo pela Lei estadual nº 15.684, de 14 de janeiro de
                | 2015, regulamentada pelo Decreto estadual nº 64.842, de 5 de março de 2020, e
                | pelo Decreto estadual nº 65.182, de 16 de setembro de 2020, compromete(m)-se,
                | perante a Coordenadoria de Assistência Técnica Integral – CATI, a executar as
                | medidas descritas no presente Termo.

        div.linha
        div.linha

        div.linha(
            v-if="informacoesMinuta.compromissarios.some(c => !c.representanteLegal)"
        )
            div.coluna
                b NOME E QUALIFICAÇÃO DOS COMPROMISSÁRIOS

        div(
            v-for="(compromissario, i) in informacoesMinuta.compromissarios"
            :key="'compromissario-' + i"
            v-if="!compromissario.representanteLegal"
        )
            div.linha
                div.coluna NOME DO COMPROMISSÁRIO(S): {{ compromissario.nome }}
            div.linha
                div.coluna CPF/CNPJ: {{ compromissario.cpf }}
            div.linha
                div.coluna Endereço: {{ compromissario.endereco }}
            div.linha
                div.coluna CEP: {{ compromissario.cep }}
            div.linha
                div.coluna Município/UF: {{ compromissario.municipio }}

        div.linha(
            v-if="informacoesMinuta.compromissarios.some(c => c.representanteLegal)"
        )
            div.coluna
                b NOME E QUALIFICAÇÃO DOS REPRESENTANTES LEGAIS

        div(
            v-for="(compromissario, i) in informacoesMinuta.compromissarios"
            :key="'representante-' + i"
            v-if="compromissario.representanteLegal"
        )
            div.linha
                div.coluna NOME DO REPRESENTANTE LEGAL: {{ compromissario.nome }}
            div.linha
                div.coluna CPF/CNPJ: {{ compromissario.cpf }}
            div.linha
                div.coluna Endereço: {{ compromissario.endereco }}
            div.linha
                div.coluna CEP: {{ compromissario.cep }}
            div.linha
                div.coluna Município/UF: {{ compromissario.municipio }}

        div.linha
            div.coluna
                b DADOS DO IMÓVEL

        div
            div.linha
                div.coluna Nome do Imóvel: {{ informacoesMinuta.imovel.nome }}
            div.linha
                div.coluna Tipo: {{ getTipoImovel(informacoesMinuta.imovel.tipo) }}
            div.linha
                div.coluna Município/UF: {{ informacoesMinuta.imovel.municipio.nome }}/{{ informacoesMinuta.imovel.municipio.codEstado }}
            div.linha(v-if='informacoesMinuta.imovel.cep')
                div.coluna CEP: {{ informacoesMinuta.imovel.cep }}
            div.linha
                div.coluna Módulos Fiscais: {{ informacoesMinuta.imovel.modulosFiscais }}

        div.linha
            div.coluna
                b Endereço Correspondência:
        div
            div.linha
                div.coluna Endereço: {{ informacoesMinuta.endereco.nomeLogradouro + ", n " + informacoesMinuta.endereco.numero }}
            div.linha
                div.coluna Bairro: {{ informacoesMinuta.endereco.bairro }}
            div.linha
                div.coluna CEP: {{ informacoesMinuta.endereco.cep }}
            div.linha
                div.coluna Município/UF: {{ informacoesMinuta.endereco.municipio.nome + informacoesMinuta.endereco.municipio.codEstado }}

        div.linha
            div.coluna
                | Os demais dados do imóvel objeto deste Termo estão especificados no Recibo do
                | CAR, que consta deste instrumento como Anexo I.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA I - DO OBJETO

        div.linha
            div.coluna
                | 1.O presente Termo tem por objeto a regularização ambiental do imóvel rural
                | indicado no campo “Dados do imóvel”, conforme o Projeto de Recomposição de
                | Áreas Degradadas e Alteradas – PRADA que consta deste TCPRA como Anexo
                | II, a ser executado nas áreas, na forma e nos prazos nele especificados, e,
                | quando houver, de acordo com as decisões judiciais e os Termos de
                | Compromisso anteriores não revistos referentes ao imóvel.
                p
                | 1.1. A assinatura deste Termo pelo(s) compromissário(s) perfaz a sua adesão
                | ao Programa de Regularização Ambiental – PRA.
                p
                | 1.2.Os Anexos deste TCPRA o integram para todos os fins como se nele
                | estivessem transcritos.
                p
                | 1.3 O TCPRA destina-se a promover as necessárias correções da propriedade
                | ou posse rural para regularização ambiental do imóvel rural, à luz da Lei
                | Federal nº 12.651, de 25 de maio de 2012, na forma do que determina o
                | Capítulo XIII da referida lei, observadas as disposições da Lei Estadual
                | 15.684/2015

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA II - COMPROMISSOS E DECISÕES JUDICIAIS ANTERIORES

        div.linha
            div.coluna
                |1.Quando houver, os Termos de Compromisso anteriores que não foram
                |revistos e/ou as decisões judiciais relacionados com a regularização do imóvel
                |rural cujas cópias constarão como Anexo III deste termo integram o presente
                |TCPRA, prevalecendo as obrigações neles estabelecidas originalmente, com
                |destaque para a forma de cumprimento e prazos.
                p
                | 2.Repactuam-se, com a assinatura deste TCPRA, eventuais Termo(s)
                | especificados no Anexo I cuja revisão foi deferida, que são ora incorporado(s) e
                | substituído(s) pelo presente instrumento, passando-se a observar as regras
                | estabelecidas no PRADA.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA III - DAS OBRIGAÇÕES DO COMPROMISSÁRIO

        div.linha
            div.coluna
                span(v-if='isRepresentanteLegal')
                    | 1. O(s) representante(s) legal(is) compromete(m)-se a:

                span(v-else)
                    | 1. O(s) compromissário(s) compromete(m)-se a:
                p
                | 1.1 adotar as medidas estabelecidas no PRADA;
                p
                | 1.2.observar o disposto na Resolução Conjunta SAA/SMA nº 03, de 16 de
                | setembro de 2020, bem como as orientações do Manual Técnico Operacional,
                | nos termos da Resolução Conjunta SAA/SIMA nº 04, de 1º de outubro de 2021,
                | alterada pela Resolução Conjunta SAA/SIMA nº 05 de 22 de outubro de 2021.
                p
                | 1.3.monitorar periodicamente as áreas de recomposição da vegetação,
                | conforme estipulado no PRADA;
                p
                | 2. Este TCPRA somente será considerado cumprido, no que diz respeito às
                | obrigações disciplinadas pela Resolução Conjunta SAA/SMA nº 03, de 16 de
                | setembro de 2020, após o alcance dos valores de referência finais dos
                | indicadores ecológicos de recomposição da vegetação, nos termos da
                | Resolução Conjunta SAA/SIMA nº 04, de 1º de outubro de 2021, alterada pela
                | Resolução Conjunta SAA/SIMA nº 05, de 22 de outubro de 2021 ou outra que
                | vier a substituí-la.
                p
                | 3. O(s) compromissário(s) obriga(se), igualmente, a:
                p
                | 3.1 utilizar, nas áreas de uso consolidado em Áreas de Preservação
                | Permanente, quando houver, técnicas de conservação do solo e da água e boas
                | práticas agronômicas que mitiguem eventuais impactos negativos no
                | ecossistema, observando a Lei estadual nº 6.171, de 04 de julho de 1988, e as
                | diretrizes estabelecidas pelo órgão competente; e
                p
                | 3.2 respeitar as áreas protegidas e a preservar a vegetação nativa existente no
                | imóvel rural, cumprindo o disposto na Lei federal nº 12.651, de 25 de maio de
                | 2012, na Lei federal nº 11.428, de 22 de dezembro de 2006, no Decreto federal
                | nº 6.660, de 21 de novembro de 2008, e na Lei estadual nº 13.550, de 02 de
                | junho de 2009.
                p
                | 4.Na hipótese de haver no imóvel drenos ou valas, o(s) compromissário(s)
                | compromete(m)-se a adotar, consoante o artigo 36, § 2º, da Lei estadual nº
                | 15.684, de 14 de janeiro de 2015, as medidas de manutenção e conservação
                | de solo e água e a comunicar a sua existência ao órgão estadual de recursos
                | hídricos, visando a sua regularização, mediante obtenção de dispensa ou
                | outorga d'água da captação ou derivação.
                p
                | 5. Caberá ao(s) compromissário(s) informar a quem couber a formalização do
                | presente TCPRA com vistas às suspensões previstas no § 5º do artigo 59 no §
                | 1º do artigo 60 da Lei 12.651/12. impostas.
                p
                | 6.Caberá ao (s) compromissário (s) informar a quem couber a emissão do
                | termo de homologação final da regularização ambiental, com vistas às
                | conversões previstas no § 5º do artigo 59, observado o disposto no artigo 19
                | do Decreto 64.842/2020, bem como para extinção do § 2º do artigo 60 da Lei
                | 12.651/12.
                p
                | 7.A compensação do deficit de Reserva Legal do imóvel objeto do presente
                | TCPRA será efetivada por meio do (s) mecanismo (s) e na (s) área (s)
                | indicados no Anexo I.
                p
                | 8.Este Termo será considerado descumprido caso haja alguma irregularidade na
                | área destinada à compensação de Reserva Legal, na hipótese em que ele seja
                | regularizada desta forma, observando-se o previsto na cláusula “Do
                | fornecimento de informações incorretas e do descumprimento das obrigações
                | constantes do presente Termo”.
                p
                | 9.O (s) compromissário (s) deverá (ão) apresentar nova proposta de instituição
                | de Reserva Legal no prazo de 06 (seis) meses antes do fim da vigência do
                | negócio jurídico referente à compensação efetivada por meio de mecanismo
                | temporário, e assim sucessivamente.
                p
                | 10.O(s) compromissário(s) se obriga(m) a inserir no CAR, como anexo, no
                | prazo de 6 (seis) meses a contar da assinatura deste Termo, a certidão da
                | matrícula expedida pelo Cartório de Registro de Imóveis competente com o
                | registro da alienação ao Poder Público da área localizada em Unidade de
                | Conservação de domínio público pendente de regularização fundiária, visando
                | a demonstrar a efetivação da regularização da Reserva Legal do imóvel,
                | quando esse for o mecanismo de compensação utilizado e a alienação ainda
                | não tiver sido registrada na matrícula do imóvel situado na Unidade de
                | Conservação. O prazo previsto neste item poderá ser prorrogado, desde que
                | o(s) titular(es) do imóvel rural apresentem justificativas que venham a ser
                | aceitas pelo órgão incumbido da análise do CAR.
                p
                | 11.Será cancelada, total ou parcialmente, a compensação da Reserva Legal
                | realizada por meio da alienação ao Poder Público da(s) área(s) especificada(s)
                | no(s) Cadastro(s) Ambiental(is) Rural(is) – CAR(s) do(s) imóvel(is) inserido(s)
                | em Unidade(s) de Conservação e cujo(s) número está(ão) indicado(s) no
                | Anexo I do presente Termo, se, dentro do prazo de 10 anos a contar do registro
                | da aludida alienação na matrícula do imóvel, ocorrer evicção ou qualquer outro
                | fato que afete a transferência da área ao Poder Público, com destaque para os
                | casos em que a alienação tiver sido efetuada por quem não era o legítimo
                | titular do domínio da área, hipótese em que o(s) compromissário(s) deverá(ão)
                | regularizar o deficit de Reserva Legal do imóvel no prazo estabelecido pelo
                | órgão competente.
                p
                | 12.As obrigações decorrentes da revisão de Termos de compromisso
                | anteriores que foram firmados com a Administração pública estadual para
                | atender a determinações do Poder Judiciário ficam com seus efeitos
                | suspensos até eventual homologação judicial da repactuação, que deverá ser
                | requerida pelo(s) compromissário(s) ao juízo competente no prazo de 30 dias
                | após a celebração do presente TCPRA.
                p
                | 13.O(s) compromissário(s) fica(m) autorizado(s) pela homologação do PRADA
                | a realizar Manejo da Vegetação de Reflorestamento nas áreas de Reserva
                | Legal para as quais tenha declarado a intenção de exploração sustentável,
                | nos termos do artigo 10 combinado com o artigo 2º, inciso XVII, ambos da
                | Resolução SMA nº 189, de 20 de dezembro de 2018, obrigando-se a alcançar
                | e a manter os valores de referência dos indicadores ecológicos de
                | recomposição da vegetação previstos no Manual Técnico Operacional a que
                | se refere o artigo 8º da Resolução Conjunta SAA/SMA nº 03, de 16 de
                | setembro de 2020. A autorização de Manejo da Vegetação de Reflorestamento
                | não implica a autorização para a Exploração Seletiva de que trata o artigo 10,
                | §1º, e artigo 2º, inciso XII, ambos da Resolução SMA nº 189, de 20 de
                | dezembro de 2018, que deverá ser obtida em procedimento específico junto
                | ao órgão estadual competente.
                p
                | 14.Adotar as providências necessárias para o alcance e a manutenção dos
                | valores de referência dos indicadores ecológicos de recomposição da
                | vegetação previstos no Manual Técnico Operacional aprovado pela Resolução
                | Conjunta SAA/SMA nº 04, de 1º de outubro de 2021.
                p
                | 15.Apresentar relatórios de implantação das fases do PRADA, assim como
                | prestar outras informações pertinentes, de acordo com a Resolução Conjunta
                | SAA/SMA nº 04, de 1º de outubro de 2021 e o Manual Técnico Operacional por
                | ela aprovado.
                p
                | 16.Caberá ao(s) compromissário(s) informar ao órgão ambiental competente a
                | formalização do presente TCPRA com vistas à suspensão, nas hipóteses
                | cabíveis, de eventuais processos referentes a sanções administrativas
                | ambientais impostas.
                p
                | 17.O(s) compromissário(s) deverá(ão) cumprir, quando houver, os Termos de
                | compromisso anteriores firmados que não foram revistos pelo presente TCPRA,
                | assim como as obrigações decorrentes das decisões judiciais relativas à
                | regularização ambiental do imóvel.
                p
                | 18.Eventuais obrigações previstas em Termo(s) no(s) qual(is) o(s)
                | compromissário(s) não figura(m) como parte, mas que estão em execução ou
                | serão executadas no imóvel objeto do presente instrumento e que integram este
                | TCPRA, terão a sua execução assumida pelo(s) compromissário(s) até o
                | alcance dos valores de referência finais dos indicadores ecológicos de
                | recomposição da vegetação previstos na Resolução Conjunta SAA/SMA nº 04,
                | de 1º de outubro de 2021, bem como no Manual Técnico Operacional por ela
                | aprovado, caso o terceiro subscritor do(s) Termo (s) não cumpra suas
                | obrigações ou tal(is) Termo(s) venha(m) a ser total ou parcialmente extinto(s)
                | antes do término da consecução do seu objeto. Na hipótese de assunção da
                | execução das obrigações pelo(s) compromissário(s), será possível a adequação
                | do cronograma original de execução previsto no(s) termo(s) de que trata este
                | item, limitada ao prazo de vigência deste TCPRA.
                p
                | 19.A quitação deste TCPRA dependerá do cumprimento, quando houver, dos
                | Termos de compromisso anteriores que não foram revistos e/ou das obrigações
                | decorrentes de decisões judiciais a que se refere a cláusula “Compromissos e
                | decisões judiciais anteriores”.
                p
                | 20.Caso a regularização da Reserva Legal seja efetivada mediante
                | compensação, o(s) mecanismo(s) utilizado(s) a(s) área(s) onde ela será
                | realizada serão indicados no Anexo I.
                p
                | 21.Quando for utilizado mecanismo temporário de compensação de Reserva
                | Legal com vistas à sua regularização, o(s) compromissário(s) deverá(ão)
                | apresentar nova proposta de instituição de Reserva Legal no prazo de 06 (seis)
                | meses antes do fim da vigência do negócio jurídico utilizado e assim sucessivamente

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA IV - DA REVISÃO E DA RETIFICAÇÃO DO TCPRA

        div.linha
            div.coluna
                | 1. O presente Termo poderá ser retificado ou revisto nas seguintes hipóteses:
                p
                | 1.1.em comum acordo entre as partes, em razão de evolução tecnológica;
                p
                | 1.2. havendo motivos justificáveis, devidamente aceitos pelo órgão subscritor do TCPRA;
                p
                | 1.3. havendo incorreções ou omissões verificadas posteriormente pelo órgão responsável por seu acompanhamento

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA V - DA VIGÊNCIA

        div.linha
            div.coluna
                | 1. Este Termo vigorará pelo prazo máximo de 20 (vinte) anos a contar da data
                | do início da execução das obrigações previstas no PRADA.
                p
                | 1.1. A vigência e a eficácia do presente Termo estão condicionadas à sua
                | inserção, pelo(s) compromissário(s), em sistema informatizado específico,
                | devidamente assinado, dentro do prazo de 90 dias contados a partir de sua
                | disponibilização pelo órgão público para assinatura ou de prazo adicional
                | concedido, conforme disposto na legislação, condição essa que não será
                | aplicável quando o TCPRA for assinado eletronicamente pelo(s)
                | compromissário(s) em sistema disponibilizado pelo SICAR-SP.
                p
                | 2. Este TCPRA poderá ser considerado cumprido antes do prazo de 20 (vinte)
                | anos, desde que os valores de referência finais dos indicadores ecológicos de
                | recomposição da vegetação tenham sido atingidos, nos termos da Resolução
                | Conjunta SAA/SMA nº 04, de 1º de outubro de 2021, alterada pela Resolução
                | Conjunta SAA/SIMA nº 05, de 15 de outubro de 2021, ou outra que vier a
                | subsisti-la.
                p
                | 3. Havendo motivo relevante e interesse das partes, o presente TCPRA poderá
                | ter seu prazo prorrogado, mediante alterações solicitadas pelo(s)
                | compromissário(s) e aprovadas pelo órgão competente.
                p
                | 4.Certificado o cumprimento das obrigações deste instrumento, a SAA, no prazo
                | de 30 (trinta) dias, emitirá termo de homologação final da regularização
                | ambiental, que será o documento hábil para reconhecimento da conversão,
                | definitiva, das multas relacionadas aos atos praticados antes de 22 de julho de
                | 2008 em serviços de preservação, melhoria e recuperação da qualidade do meio
                | ambiente, bem como da extinção da punibilidade nos termos do disposto no art.
                | 60, § 2º da Lei 12.651/2012.
                p
                | 5.Caberá ao proprietário ou possuidor rural comunicar o cumprimento do TCPRA
                | à Secretaria de Infraestrutura e Meio Ambiente.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VI - DO FORNECIMENTO DE INFORMAÇÕES INCORRETAS E
                 | DO DESCUMPRIMENTO DAS OBRIGAÇÕES CONSTANTES DO PRESENTE TERMO

        div.linha
            div.coluna
                | 1.O descumprimento do TCPRA, após esgotadas as medidas previstas no artigo
                | 5º da Resolução Conjunta SAA/SIMA nº 3, de 16 de setembro de 2020,
                | garantidos o contraditório, a ampla defesa e não havendo possibilidade de
                | regularização, acarretará na execução do TCPRA, com finalidade de se ver
                | cumprida a obrigação de fazer, individualizada noGo processo administrativo,
                | bem como na a cobrança de multa moratória de 0,25 UFESP por dia para cada
                | hectare no qual forem descumpridas as obrigações de recomposição da
                | vegetação, a contar da data do descumprimento.
                p
                | Parágrafo único – O inadimplemento implicará na perda dos direitos previstos no
                | § 5º do artigo 59 e no artigo 60 da Lei 12.651/2012.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VII – DO TÍTULO EXECUTIVO.

        div.linha
            div.coluna
                | Este Termo constitui título executivo extrajudicial, consoante o disposto no § 3º
                | do artigo 59 da Lei federal nº 12.651, de 25 de maio de 2012, combinado com o
                | inciso II do artigo 784 da Lei federal nº 13.105, de 16 de março de 2015 e com o
                | artigo 5º, § 6º, da Lei federal nº 7.347, de 24 de julho de 1985.

        div.linha
        div.linha

        div.linha
            div.coluna
                b CLÁUSULA VIII - DO FORO

        div.linha
            div.coluna
                | Fica eleito o foro da sede da Procuradoria Regional da Procuradoria Geral do
                | Estado de São Paulo cuja área de atuação abarque o local onde o imóvel rural de
                | que trata este Termo se situa, ou, se for o caso, o da Capital, para dirimir as
                | questões oriundas deste instrumento que não sejam resolvidas
                | administrativamente pelas partes.
                p
                | Nada mais havendo, o presente termo é rubricado em todas as páginas, firmado
                | e inserido em sistema informatizado específico.
</template>

<script>
import { TipoImovelEnum } from '@/enums/imovel.enum.js';
export default {

    name: 'MinutaTCPRATextoComponent',

    props: {
        informacoesMinuta: {
            type: Object,
            required: true
        },
        isRepresentanteLegal: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
        }
    },
    methods: {
        getTipoImovel(idTipo) {
            return TipoImovelEnum[idTipo].nome;
        }
    }
}
</script>

<style lang="scss" scoped>
.minutaContent {
    padding: 10px;
    background-image: url("../../../assets/marca-dagua.jpg");

    .centralizado {
        display: flex;
        align-content: center;
        justify-content: center;
    }
}
</style>
